import React, { Component } from "react";
import Global from "../../../Global";
import NavLink from "./NavLink";
import MainNav from "./MainNav";
import LoginMessageBox from "../../../components/common/LoginMessageBox";

import "./navigation.css";
import NavigationMobile from "./NavigationMobile";
import Search from "../Search";
import DtApiUtil from "../../../utils/DtApiUtil";
import BauUtil from "../../../utils/BauUtils";

class NavV2 extends Component {
  constructor(props) {
    super(props);

    let infoObj = this.getInfoFromSession();

    this.state = {
      isShownLoginWarning: false,
      messageLoginWarning: "",

      ready: false,
      login: {},
      topLink: {},
      topNavMenu: {},
      general: {},
      theme: {},
      loginProfile: {
        isLogin: infoObj.isLogin,
        hasLoginError: false,
        msisdn: infoObj.msisdn,
        username: infoObj.username,
        inputMSISDN: "",
        inputPW: "",
        loginDialogDisplay: false,
        afterLoginDialogDisplay: "none",
        isDtAccount: false,
        dtProfilePic: "",
        isEnableTouchPointOnlineRetention:infoObj.isEnableTouchPointOnlineRetention,
        isEnableTouchPointCVM: infoObj.isEnableTouchPointCVM,
        errorDetail: "",
        loginRemark: "",
        otp:new Array(6),
        loginStep:'ENTER_LOGIN_ID',
        isResendOTPButtonShown: false,
      },
      currentSelectedTab: "traditional",
      searchResultStates: {
        searchResultsData: { searchResults: [] },
        searchNotFound: false,
      },
    };
  }

  showLoginWarning() {
    this.setState({ isShownLoginWarning: true });
    document.body.style.overflow = "hidden";
  }

  hideLoginWarning() {
    this.setState({ isShownLoginWarning: false });
    document.body.style.overflow = "scroll";
  }

  componentWillMount = async () => {
    let response = await fetch(Global.getAPI("top-navigation"));
    if (response.status >= 400) throw new Error("Error API: phone-detail");
    let responseJson = await response.json();

    let loginProfile = this.state.loginProfile;
    let sessionResult = this.getInfoFromSession();

    if (sessionResult.isLogin === true) {
      loginProfile.isLogin = true;
      loginProfile.msisdn =
        sessionResult.msisdn !== "" ? sessionResult.msisdn : "";
      loginProfile.username = sessionResult.username;
      loginProfile.loginDialogDisplay = false;
      loginProfile.isEnableTouchPointOnlineRetention =
        sessionResult.isEnableTouchPointOnlineRetention;
      loginProfile.isEnableTouchPointCVM = sessionResult.isEnableTouchPointCVM;
    }

    if (loginProfile.isLogin === false) {
      let loginStatusResponse = await DtApiUtil.userGetLoginStatus();
      let loginStatusResult = await DtApiUtil.getLoginStatusResult(
        loginStatusResponse
      );

      if (loginStatusResult.isLogin === true) {
        /* Basic Setup For DT Account */
        loginProfile.isLogin = true;
        loginProfile.isDtAccount = true;
        loginProfile.loginDialogDisplay = false;
        loginProfile.msisdn = loginStatusResult.displayName;
        loginProfile.serviceType = loginStatusResult.serviceType;
        loginProfile.username = "";

        if (loginStatusResult.subscriptionId === "") {
          let getProfilePicResult = await DtApiUtil.userGetProfilePic();
          loginProfile.dtProfilePic = await DtApiUtil.getCustLevelProfilePic(
            getProfilePicResult
          );
        } else {
          let subProfilePicResult = await DtApiUtil.simGetProfilePic(
            loginStatusResult.subscriptionId
          );
          loginProfile.dtProfilePic = await DtApiUtil.getSubProfilePic(
            subProfilePicResult
          );
        }
      }
    }

    this.setState({ ...responseJson, loginProfile: loginProfile, ready: true });
  };

  getInfoFromSession = () => {

    const defaultLoginInfo = {
      msisdn: "",
      username: "",
      isLogin: false,
      isEnableTouchPointOnlineRetention: false,
      isEnableTouchPointCVM: false,
    };

    const cookieName = "BTkPFJMohHNmRD";
    const cookieProfile = Global.getCookie(cookieName);
    if (cookieProfile.length == 0) return defaultLoginInfo;

    return {
      msisdn: cookieProfile.split("|")[1],
      username: cookieProfile.split("|")[3],
      isLogin: true,
      isEnableTouchPointOnlineRetention: cookieProfile.split("|")[6] == "true",
      isEnableTouchPointCVM: cookieProfile.split("|")[7] == "true",
    };
  };

  whenPressEnter = (e) => {
    const { loginStep } = this.state.loginProfile;
    if (e.key !== "Enter") return;
    switch(loginStep){
      case 'ENTER_LOGIN_ID':
        this.handleCheckLoginId();
        break;
      case 'ENTER_LOGIN_PASSWORD':
        this.handleSendLoginIdOTP();
        break;
      case 'ENTER_LOGIN_OTP':
          return;
      default:
        break;
    }
  };

  updateInputMSISDN = (e) => {
    let loginProfile = this.state.loginProfile;
    loginProfile.inputMSISDN = e.target.value;
    this.setState({ loginProfile: loginProfile });
  };

  updateInputPW = (e) => {
    let loginProfile = this.state.loginProfile;
    loginProfile.inputPW = e.target.value;
    this.setState({ loginProfile: loginProfile });
  };


  setOtp = (e,index) => {
    const {loginProfile} = this.state;
    const {otp} = loginProfile;

    if(typeof e.clipboardData !== 'undefined'){
      const pasteData = e.clipboardData.getData('text') || '';
      loginProfile.otp = pasteData.padEnd(6).slice(0,6).split('').map(i=>i.trim());
      this.setState({ loginProfile: loginProfile }); 
      return;
    }

    otp[index] = e.target.value;
    loginProfile.otp = otp;
    this.setState({ loginProfile: loginProfile }); 
  };

  /* DT Redirection */
  goToDtPlatform = () => {
    const lang = window.THREE_REACT_APP_GLOBAL.language;
    const { serviceType } = this.state.loginProfile;

    // DT PREPAID Login Platform
    if (serviceType === "PREPAID") {
      window.location.href = `${
        process.env.REACT_APP_DT_PREPAID_BASE_URL
      }/DIY/${lang}/account/dashboard/purchase`;
      return;
    }

    // DT POSTPAID Login Platform
    window.location.href = `${
      process.env.REACT_APP_DT_POSTPAID_BASE_URL
    }/${lang}/account/`;
    return;
  };

  updateLoginMode = (m) => {
    this.setState({ currentSelectedTab: m });
  };

  updateLoginStep = (loginStep, errorDetail = '', loginRemark = '') => {
    const { loginProfile } = this.state;
    if(loginStep === 'ENTER_LOGIN_ID'){
      loginProfile.inputMSISDN = "";
      loginProfile.inputPW = "";
    }

    loginProfile.errorDetail = errorDetail;
    loginProfile.loginRemark = loginRemark;
    loginProfile.loginStep = loginStep;
    loginProfile.otp = new Array(6);

    this.setState({
      loginProfile,
    });
  }
  

  handleCheckLoginId = async () => {

    const lang = window.THREE_REACT_APP_GLOBAL.language || "en";

    const { loginProfile } = this.state;
    const { inputMSISDN } = loginProfile;

    let loginId = inputMSISDN.trim();

    if (!loginId) {
      loginProfile.errorDetail = lang === "en" ? "Invalid phone Number / email, please re-enter" :"請輸入正確電話號碼 / 登入電郵地址"
      this.setState({
        loginProfile: loginProfile,
      });
      return;
    }

    document.getElementById("navLoginSpinner").style.display = "block";

    const checkLoginIdResponse = await DtApiUtil.checkLoginId(loginId, lang);

    const { platform, isSUPREME, targetUrl,errorDetail } = checkLoginIdResponse;
    document.getElementById("navLoginSpinner").style.display = "none";

    if (platform == "DT") {
      window.location.href = targetUrl;
      return;
    } else if (platform == "BAU") {
      if (isSUPREME) {
        this.navHideLoginDialog();
        this.showLoginWarning();
        loginProfile.inputMSISDN = "block";

        this.setState({
          loginProfile: loginProfile,
          messageLoginWarning: errorDetail,
        });
        return;
      }
      this.updateLoginStep('ENTER_LOGIN_PASSWORD');
      return;
    }

    // Non DT & Non BAU
    window.location.href = targetUrl;
    return;
  };

  navDoLogin = async () => {

    const lang = window.THREE_REACT_APP_GLOBAL.language || "en";
    const langBAUPlatform = lang === "en" ? "eng" : "chi";

    const { loginProfile } = this.state;

    const { inputMSISDN, inputPW, otp } = loginProfile;


    /* Flush DT Related Info 1st */
    loginProfile.isDtAccount = false;
    loginProfile.dtProfilePic = "";

    const loginId = inputMSISDN.trim();
    const password = inputPW.trim();

    const otpInput = otp.join('');

    // Empty Input
    if (!loginId || !password || !otpInput || otpInput.length !== 6) {
      loginProfile.errorDetail = lang === "en" ? "Please enter One-Time Password" : "請輸入一次性驗證碼";
      this.setState({
        loginProfile: loginProfile,
      });
      return;
    }

    document.getElementById("navLoginSpinner").style.display = "block";
    try {
      const loginResponse = await BauUtil.login(loginId, password,otpInput,langBAUPlatform);

      document.getElementById("navLoginSpinner").style.display = "none";

      if (loginResponse.status >= 400) throw new Error("Error API: Logout API");

      const { result, custId, isSupreme, errorDetail } = loginResponse.data;

      if (!result) {
        if (isSupreme) {
          this.navHideLoginDialog();
          this.showLoginWarning();
        } else {
          loginProfile.otp = new Array(6);
          this.updateLoginStep(
            'ENTER_LOGIN_ID',
            errorDetail != null ? errorDetail : '',
           );

          if(errorDetail.includes('請再發送一次密碼') || errorDetail.includes('Please request one time password')){
            loginProfile.isResendOTPButtonShown = true;
          }

          this.setState({
            loginProfile: loginProfile,
          });
        }
        return;
      }

      let sessionResult = this.getInfoFromSession();

      loginProfile.isLogin = true;
      loginProfile.msisdn = sessionResult.msisdn !== "" ? sessionResult.msisdn : loginId;
      loginProfile.username = sessionResult.username;
      loginProfile.loginDialogDisplay = false;
      loginProfile.isEnableTouchPointOnlineRetention = sessionResult.isEnableTouchPointOnlineRetention;
      loginProfile.isEnableTouchPointCVM = sessionResult.isEnableTouchPointCVM;
      loginProfile.loginStep = 'ENTER_LOGIN_ID';

      this.setState({
        loginProfile: loginProfile,
      });
    } catch (e) {
      document.getElementById("navLoginSpinner").style.display = "none";
      loginProfile.loginStep = 'ENTER_LOGIN_ID';
      this.setState({
        loginProfile: loginProfile,
      });
    }
  };

  handleSendLoginIdOTP = async()=>{
    const lang = window.THREE_REACT_APP_GLOBAL.language || "en";
    const langBAUPlatform = lang === "en" ? "eng" : "chi";

    const { loginProfile } = this.state;

    const { inputMSISDN, inputPW } = loginProfile;

    const loginId = inputMSISDN.trim();
    const password = inputPW.trim();

    // Empty Input
    if (!loginId || !password) {
      loginProfile.errorDetail = lang === "en" ? "Please enter password" : "請輸入密碼"
      this.setState({
        loginProfile: loginProfile,
      });
      return;
    }

    document.getElementById("navLoginSpinner").style.display = "block";
    try {
      const resp = await BauUtil.sendLoginOTP(loginId, password,langBAUPlatform);

      document.getElementById("navLoginSpinner").style.display = "none";

      if (resp.status >= 400) throw new Error("Error API: SendLoginIdOTPAction.do");

      const { isSuccess, isSupreme,errorDetail,loginRemark} = resp.data;

      if(!isSuccess){
        if (isSupreme) {
          this.navHideLoginDialog();
          this.showLoginWarning();
        } else {
          loginProfile.errorDetail = errorDetail != null ? errorDetail : '';
          this.setState({
            loginProfile: loginProfile,
          });
        }
        return;
      }

      loginProfile.loginStep = 'ENTER_LOGIN_OTP';
      loginProfile.errorDetail = '';
      loginProfile.loginRemark = loginRemark;
      loginProfile.isResendOTPButtonShown = false;
      this.setState({
        loginProfile: loginProfile,
      });
    } catch (e) {
      console.error(e);
      document.getElementById("navLoginSpinner").style.display = "none";

      this.setState({
        loginProfile: loginProfile,
      });
    }

  };


  navDoLogout = async () => {
    let loginProfile = this.state.loginProfile;

    try {
      document.getElementById("navLoginSpinner2").style.display = "block";

      const logoutResponse = await BauUtil.logout();
      const { result, status } = logoutResponse.data;

      if (status >= 400) throw new Error("Error API: Logout API");

      document.getElementById("navLoginSpinner2").style.display = "none";

      if (result) {
        loginProfile.isLogin = false;
        loginProfile.msisdn = "";
        loginProfile.username = "";
        loginProfile.loginDialogDisplay = false;
      }

      this.setState({
        loginProfile: loginProfile,
      });
    } catch (e) {
      console.error(e);
      document.getElementById("navLoginSpinner2").style.display = "none";
      this.setState({
        loginProfile: loginProfile,
      });
    }
  };

  navShowLoginDialog = () => {
    let loginProfile = this.state.loginProfile;

    if (loginProfile.loginDialogDisplay === false) {
      loginProfile.loginDialogDisplay = true;
      this.setState({
        loginProfile: loginProfile,
      });
    }
  };

  navHideLoginDialog = () => {
    let loginProfile = this.state.loginProfile;

    if (loginProfile.loginDialogDisplay === true) {
      loginProfile.loginDialogDisplay = false;
      this.setState({
        loginProfile: loginProfile,
      });
    }
  };

  navFlipLoginDialog = () => {
    let loginProfile = this.state.loginProfile;

    loginProfile.loginDialogDisplay = !loginProfile.loginDialogDisplay;
    this.setState({
      loginProfile: loginProfile,
    });
  };

  renderCommonInputFields = () => {
    let loginProfile = this.state.loginProfile;
    let loginBlock = this.state.login.block;

    // let userIdPlaceholder = loginBlock.userIdPlaceHolder;
    const lang = window.THREE_REACT_APP_GLOBAL.language || "en";
    const labelPhoneNumberLoginEmail = lang === "en" ? "Phone Number / Email" : "電話號碼 / 登入電郵地址";
    // const labelLoginIdError = lang === "en" ? "Invalid phone Number / email, please re-enter" :"請輸入正確電話號碼 / 登入電郵地址";

    return (
      <React.Fragment>
        <div className="label-user-id">{labelPhoneNumberLoginEmail}</div>
        <input
          type="text"
          className="userid"
          onChange={(e) => this.updateInputMSISDN(e)}
          onKeyDown={(e) => this.whenPressEnter(e)}
        />
      </React.Fragment>
    );
  };

  //Login Logic Ended
  setSearchResultStates = (data, isFound) => {
    this.setState({
      searchResultStates: {
        searchResultsData: data,
        searchNotFound: isFound,
      },
    });
  };

  render() {
    if (!this.state.ready) {
      return false;
    } else {
      return (
        <div className={"nav-v2 navigation"}>
          <LoginMessageBox
            message={this.state.messageLoginWarning}
            isVisible={this.state.isShownLoginWarning}
            handleDismiss={() => this.hideLoginWarning()}
          />
          <div className={"desktop-size"}>
            <NavLink
              isMobile={false}
              topLink={this.state.topLink}
              langs={this.state.langs}
              /** UI Presentation Part**/
              theme={this.state.theme}
              login={this.state.login}
              /** Login Param and Func Part **/
              loginProfile={this.state.loginProfile}
              navShowLoginDialog={() => this.navShowLoginDialog()}
              navHideLoginDialog={() => this.navHideLoginDialog()}
              navFlipLoginDialog={() => this.navFlipLoginDialog()}
              updateInputMSISDN={(e) => this.updateInputMSISDN(e)}
              updateInputPW={(e) => this.updateInputPW(e)}
              renderCommonInputFields={() => this.renderCommonInputFields()}
              navDoLogin={() => this.navDoLogin()}
              handleCheckLoginId={() => this.handleCheckLoginId()}
              handleSendLoginIdOTP={()=>this.handleSendLoginIdOTP()}
              navDoLogout={() => this.navDoLogout()}
              currentSelectedTab={this.state.currentSelectedTab}
              goToDtPlatform={() => this.goToDtPlatform()}
              updateLoginMode={(m) => this.updateLoginMode(m)}
              updateLoginStep={(step)=>this.updateLoginStep(step)}
              whenPressEnter={(e) => this.whenPressEnter(e)}
              setOtp={this.setOtp}
            />
            <MainNav
              /** UI Presentation Part**/
              general={this.state.general}
              topNavMenu={this.state.topNavMenu}
              theme={this.state.theme}
              login={this.state.login}
              /** Login Param and Func Part **/
              loginProfile={this.state.loginProfile}
              navShowLoginDialog={() => this.navShowLoginDialog()}
              navHideLoginDialog={() => this.navHideLoginDialog()}
              navFlipLoginDialog={() => this.navFlipLoginDialog()}
              updateInputMSISDN={(e) => this.updateInputMSISDN(e)}
              updateInputPW={(e) => this.updateInputPW(e)}
              renderCommonInputFields={() => this.renderCommonInputFields()}
              searchResultStates={this.state.searchResultStates}
              navDoLogin={() => this.navDoLogin()}
              navDoLogout={() => this.navDoLogout()}
              currentSelectedTab={this.state.currentSelectedTab}
              goToDtPlatform={() => this.goToDtPlatform()}
              updateLoginMode={(m) => this.updateLoginMode(m)}
            />
          </div>
          <div className={"mobile-size"}>
            <MainNav
              isMobile={true}
              general={this.state.general}
              topNavMenu={this.state.topNavMenu}
              login={this.state.login}
              theme={this.state.theme}
              /** Login Param and Func Part **/
              loginProfile={this.state.loginProfile}
              navShowLoginDialog={() => this.navShowLoginDialog()}
              navHideLoginDialog={() => this.navHideLoginDialog()}
              navFlipLoginDialog={() => this.navFlipLoginDialog()}
              updateInputMSISDN={(e) => this.updateInputMSISDN(e)}
              updateInputPW={(e) => this.updateInputPW(e)}
              renderCommonInputFields={() => this.renderCommonInputFields()}
              navDoLogin={() => this.navDoLogin()}
              navDoLogout={() => this.navDoLogout()}
              searchResultStates={this.state.searchResultStates}
              currentSelectedTab={this.state.currentSelectedTab}
              goToDtPlatform={() => this.goToDtPlatform()}
              updateLoginMode={(m) => this.updateLoginMode(m)}
            />
            <NavigationMobile
              theme={this.state.theme}
              topLink={this.state.topLink}
              langs={this.state.langs}
              topNavMenu={this.state.topNavMenu}
              login={this.state.login}
              searchLabel={this.state.search}
              loginProfile={this.state.loginProfile}
              navShowLoginDialog={() => this.navShowLoginDialog()}
              navHideLoginDialog={() => this.navHideLoginDialog()}
              updateInputMSISDN={(e) => this.updateInputMSISDN(e)}
              updateInputPW={(e) => this.updateInputPW(e)}
              renderCommonInputFields={() => this.renderCommonInputFields()}
              navDoLogin={() => this.navDoLogin()}
              handleCheckLoginId={() => this.handleCheckLoginId()}
              handleSendLoginIdOTP={()=>this.handleSendLoginIdOTP()}
              navDoLogout={() => this.navDoLogout()}
              currentSelectedTab={this.state.currentSelectedTab}
              goToDtPlatform={() => this.goToDtPlatform()}
              updateLoginMode={(m) => this.updateLoginMode(m)}
              updateLoginStep={(step)=>this.updateLoginStep(step)}
              whenPressEnter={(e) => this.whenPressEnter(e)}
              setOtp={this.setOtp}
            />
          </div>
          <div className={"search-block"}>
            <Search
              searchResultStates={this.state.searchResultStates}
              setSearchResultStates={(data, isFound) =>
                this.setSearchResultStates(data, isFound)
              }
            />
          </div>
          <div
            id="navLoginSpinner"
            style={{ display: "none" }}
            className={"loading"}
          >
            Loading&#8230;
          </div>
          <div
            id="navLoginSpinner2"
            style={{ display: "none" }}
            className={"loading"}
          >
            Loading&#8230;
          </div>
        </div>
      );
    }
  }
}

export default NavV2;
